import { GenericInput } from "../../components/inputs/GenericInput";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Divider } from "@mantine/core";
import UnregisteredFunctions from "./UnregisteredFunctions";

export default function MappingHeader(props: {
  mapperName: string;
  setMapperName: (mapperName: string) => void;
  isNew?: boolean;
  onSave: () => void;
  unRegFuncMap: Map<string, string>;
  setUnRegFuncMap:React.Dispatch<React.SetStateAction<Map<string, string>>>
}) {
  return (
    <>
      <Stack spacing={2}>
        <Box>
          <Typography textAlign={"center"} variant="h4" component={"h3"}>
            Create Mapping Transformer
          </Typography>
          <Divider sx={{ width: "90%", margin: "auto" }} my={"20px"} />
        </Box>

        <Box display={"flex"} justifyContent={"center"}>
          <GenericInput
            textFieldInputProps={{
              disabled: !props.isNew || false,
              style: { width: "60%" },
              label: "Transformer Name",
              fullWidth: true,
              value: props.mapperName,
              onChange: (e) => props.setMapperName(e.target.value),
            }}
          />
        </Box>

        <Box display={"flex"} justifyContent={"space-between"} paddingX={4}>
           <UnregisteredFunctions
              unRegFuncMap={props.unRegFuncMap}
              setUnRegFuncMap={props.setUnRegFuncMap}
            />
          <Button variant="outlined" onClick={props.onSave}>
            Save Transformer
          </Button>
        </Box>
      </Stack>
    </>
  );
}